var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBadgeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3378F9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.6,25.4H79.1v-2.6c0-3-2.4-5.4-5.5-5.4H57.4c0.6-1.3,0.9-2.7,0.9-4.2c0-5.6-4.5-10.1-10.1-10.1 c-5.6,0-10.1,4.5-10.1,10.1c0,1.5,0.3,2.9,0.9,4.2H23c-3,0-5.5,2.4-5.5,5.4v2.6H6.9c-3.5,0-6.4,2.9-6.4,6.4v51.6 c0,3.5,2.9,6.4,6.4,6.4h82.7c3.5,0,6.4-2.9,6.4-6.4V31.8C96,28.2,93.1,25.4,89.6,25.4L89.6,25.4z M21.3,22.8c0-0.9,0.8-1.7,1.7-1.7 h19.5c1,0,1.9-0.8,1.9-1.9v-0.2c0-0.5-0.2-1-0.6-1.3c-1.2-1.2-1.9-2.8-1.9-4.6c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3 c0,1.7-0.6,3.2-1.8,4.4c-0.3,0.3-0.5,0.8-0.5,1.3v0.4c0,1,0.8,1.9,1.9,1.9h19.5c1,0,1.7,0.8,1.7,1.7v2.6H21.3V22.8z M92.3,83.4 c0,1.5-1.2,2.7-2.7,2.7H6.9c-1.5,0-2.7-1.2-2.7-2.7V31.8c0-1.5,1.2-2.7,2.7-2.7h82.7c1.5,0,2.7,1.2,2.7,2.7V83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,37.7H12.3c-1,0-1.9,0.8-1.9,1.9v38.2c0,1,0.8,1.9,1.9,1.9h34.4c1,0,1.9-0.8,1.9-1.9V39.6 C48.5,38.5,47.7,37.7,46.7,37.7L46.7,37.7z M44.8,75.9H14.1V41.4h30.7V75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.3,39.1H56.7c-1,0-1.9,0.8-1.9,1.9c0,1,0.8,1.9,1.9,1.9h25.6c1,0,1.9-0.8,1.9-1.9 C84.1,39.9,83.3,39.1,82.3,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.3,47.5H56.7c-1,0-1.9,0.8-1.9,1.9s0.8,1.9,1.9,1.9h25.6c1,0,1.9-0.8,1.9-1.9S83.3,47.5,82.3,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.3,55.9H56.7c-1,0-1.9,0.8-1.9,1.9c0,1,0.8,1.9,1.9,1.9h25.6c1,0,1.9-0.8,1.9-1.9 C84.1,56.8,83.3,55.9,82.3,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.3,65.9H56.7c-1,0-1.9,0.8-1.9,1.9v10c0,1,0.8,1.9,1.9,1.9h25.6c1,0,1.9-0.8,1.9-1.9v-10 C84.1,66.8,83.3,65.9,82.3,65.9z M80.4,75.9H58.5v-6.3h21.9L80.4,75.9L80.4,75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,10.9c-1,0-1.9,0.8-1.9,1.9v0.6c0,1,0.8,1.9,1.9,1.9c1,0,1.9-0.8,1.9-1.9v-0.6 C50.2,11.7,49.4,10.9,48.3,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.2,68.2c1,0,1.9-0.8,1.9-1.9v-1c0-1.1,0.9-2,2-2h6.8c1.1,0,2,0.9,2,2v1c0,1,0.8,1.9,1.9,1.9 c1,0,1.9-0.8,1.9-1.9v-1c0-2.2-1.3-4.2-3.2-5.1c0.8-1.1,1.2-2.5,1.2-4c0-3.9-3.2-7.1-7.1-7.1s-7.1,3.2-7.1,7.1c0,1.5,0.4,2.8,1.2,4 c-1.9,0.9-3.2,2.9-3.2,5.1v1C20.4,67.4,21.2,68.2,22.2,68.2L22.2,68.2z M29.5,52.9c1.9,0,3.4,1.5,3.4,3.4s-1.5,3.4-3.4,3.4 c-1.9,0-3.4-1.5-3.4-3.4S27.6,52.9,29.5,52.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadgeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BadgeIcon.d5f054f7.svg";
export { ForwardRef as ReactComponent };